import React from 'react';

const CloseQuote: React.FC = () => {
  return (
    <svg width="79" height="59" viewBox="0 0 79 59" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M74.9932 25.0639L48.2717 59L37.2437 59L56.5426 27.0601C52.7253 23.5113 50.8166 19.4449 50.8166 14.8609C50.8166 10.8684 52.2304 7.39348 55.0581 4.43609C57.7444 1.4787 60.9962 -1.61637e-06 64.8136 -1.27001e-06C68.6309 -9.2364e-07 71.9534 1.4787 74.7811 4.43609C77.4674 7.39349 78.8106 10.8684 78.8106 14.8609C78.8106 18.7055 77.5381 22.1065 74.9932 25.0639ZM38.5162 25.0639L11.7947 59L0.766754 59L20.0656 27.0601C16.2483 23.5113 14.3396 19.4449 14.3396 14.8609C14.3396 10.8684 15.7534 7.39348 18.5811 4.43608C21.2674 1.47869 24.5192 -4.92608e-06 28.3366 -4.57972e-06C32.1539 -4.23335e-06 35.4765 1.47869 38.3041 4.43608C40.9904 7.39348 42.3336 10.8684 42.3336 14.8609C42.3336 18.7055 41.0611 22.1065 38.5162 25.0639Z"
        fill="#B4FA05"
      />
    </svg>
  );
};

export { CloseQuote };
